import { NavLink, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { NeedsReviewPage } from './pages/NeedsReview.js';
import { SuppressorsPage } from './pages/Suppressors.js';
import { ColorsPage } from './pages/Colors.js';
import { VariantMappingsPage } from './pages/VariantMappings.js';
import { ImportsPage } from './pages/Imports.js';

const isDev = import.meta.env.MODE !== 'production';

export function App(): JSX.Element {
  return (
    <Router>
      <div className="shell">
        <nav className="side">
          <span className="brand">BPG Admin</span>
          <NavLink to="/needs-review" className={({ isActive }) => (isActive ? 'active' : '')}>Needs Review</NavLink>
          <NavLink to="/suppressors" className={({ isActive }) => (isActive ? 'active' : '')}>Suppressors</NavLink>
          <NavLink to="/colors" className={({ isActive }) => (isActive ? 'active' : '')}>Colors</NavLink>
          <NavLink to="/variant-mappings" className={({ isActive }) => (isActive ? 'active' : '')}>Variant Mappings</NavLink>
          <NavLink to="/imports" className={({ isActive }) => (isActive ? 'active' : '')}>Imports</NavLink>
        </nav>
        <main>
          {isDev && (
            <div className="dev-banner">
              Dev mode — authenticating with VITE_DEV_TOKEN. Production uses Cloudflare Access SSO.
            </div>
          )}
          <Routes>
            <Route path="/" element={<NeedsReviewPage />} />
            <Route path="/needs-review" element={<NeedsReviewPage />} />
            <Route path="/suppressors" element={<SuppressorsPage />} />
            <Route path="/colors" element={<ColorsPage />} />
            <Route path="/variant-mappings" element={<VariantMappingsPage />} />
            <Route path="/imports" element={<ImportsPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}
